import * as types from '../../../redux/actionTypes';
import initialState from '../../../redux/initialState';

export default function authReducer(state = initialState.auth, action) {
  switch (action.type) {
    case types.LOAD_USER_DATA_SUCCESS:
      return { ...state, data: action.data };

    case types.LOAD_TENANTS_IDS_FOR_USER:
      return { ...state, tenantIds: action.tenants };

    case types.LOAD_TENANT_AGREEMENTS_IDS_FOR_USER:
      return { ...state, tenantAgreementIds: action.custom_agreements };

    case types.SESSION_CHECK_BEGIN:
      return { ...state, isLoading: true, error: null };

    case types.SESSION_CHECK_SUCCESS: {
      const { result } = action;
      const { user } = result;
      const nextState = {
        ...state,
        // if the session is no longer valid, we keep the same user information
        // we had before
        isAuthenticated: result.isAuthenticated || state.isAuthenticated,
        user: user ? { ...user, user_id: user.id, sub: user.id } : state.user,
        isLoading: false,
        error: null
      };
      if (state.isAuthenticated && !result.isAuthenticated) {
        nextState.sessionExpired = true;
      }
      return nextState;
    }

    case types.SESSION_CHECK_FAILED:
      return { ...state, error: action.error, isLoading: false };


    case types.INITIAL_AUTH_STATE_SUCCESS: {
      const { result } = action;
      const { user } = result;

      return {
        ...state,
        isAuthenticated: result.isAuthenticated,
        user: user ? { ...user, user_id: user.id, sub: user.id } : {},
        isLoading: false,
        error: null
      };
    }

    case types.LOAD_AUTHENTICATION_STATUS:
      return { ...state, status: action.status };

    case types.LOAD_AUTHENTICATION_STATUS_ERROR:
      return { ...state, error: `An error occurred while authenticating: ${action.errorMessage}` };

    default:
      return state;
  }
}
